import NewItemAdjustment from "../../../../components/@documents/item_adjustments/NewItemAdjustment";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function ItemAdjustmentNewPage() {

    return (
        <NewItemAdjustment 
            routeType={routeTypes.admin}
        />
    )
}